import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a69a4592")

_pushScopeId("data-v-a69a4592")
const _hoisted_1 = { class: "export-dialog" }
const _hoisted_2 = { class: "preview" }
const _hoisted_3 = { class: "handle" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("pre", null, _toDisplayString(_ctx.slides), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        class: "btn",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportJSON()))
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emit('close')))
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
})